import React, { Component } from 'react'
import { connect } from 'react-redux';
import FolderManagerHeader from '../../folderManager/FolderManagerHeader';
import AllFolders from '../../folderManager/AllFolders';
import CreateCompanyButton from '../../company/CreateCompanyButton';
import Loader from 'react-loader-spinner';

class DashboardFolders extends Component {
    render() {
        const { companyData, themeColors } = this.props;

        const header = companyData !== undefined ?
            (companyData != null ? (<FolderManagerHeader />) : (<CreateCompanyButton />)) :
            (<Loader
                type="TailSpin"
                color={themeColors.themeColor}
                height={20}
                width={20}
            />
            );

        return (
            <div className="container-fluid">
                <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '80px' }}>
                    <div className="card-header" style={{ textAlign: "start", fontWeight: "bold" }}>
                        {header}
                    </div>
                    <div className="p-3 pt-5">
                        <AllFolders />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        companyData: state.firestore.data.Company,
    }
}

export default connect(mapStateToProps)(DashboardFolders);